import { useContext } from 'react'
import ManagersContext from '../../containers/ManagersContext'
import wikiExternal from '../../image/wikipediaExternalPage.png'

export default function InnerPageTalks () {
  const {talksManager} = useContext(ManagersContext)

  return (
    <div>
      <header>
        <h1>Talks</h1>
        <p>
          These are talks I have given on various technologies.  They were originally PowerPoint decks, but the items below link to Google Docs versions of them.
        </p>
      </header>
      {
        talksManager.talksData.map((talk, i) => (
          <dl key={`talk_${i}`}>
            <dt>
              <a href={talk.url} rel="noreferrer" target="_blank">{talk.title}</a>&nbsp;<img src={wikiExternal} alt='External Page' />
            </dt>
            <dd>{talk.description}</dd>
          </dl>
        ))
      }
    </div>
  )
}
